import { TStorePaths } from '@/common/types/storePaths';

import { TChartBaseConfig, TChartItem } from '../components/statistics/charts/chartTypes';
import { TStatisticsChartWithLegends } from '../types/statistics/common';

const CHART_LINE_KEYS = ['firstLine', 'secondLine', 'thirdLine', 'fourthLine'] as const;

export const STATISTICS_PUBLIC_CHART_LINE_COLORS = ['#73EA48', '#17A1FA', '#FA1717', '#FAF217'];

export const getStatisticsChartWithLegendsConfigs = (
  storePaths: TStorePaths,
): TChartBaseConfig<TStatisticsChartWithLegends> => ({
  storePaths,
  labelKey: 'label',
  tooltip: {
    key: 'text',
  },
  columns: [
    {
      name: (rawData) => rawData.legends.column,
      valueKey: 'column',
    },
  ],
  lines: CHART_LINE_KEYS.map((lineKey) => ({
    name: (rawData) => rawData.legends[lineKey] ?? '',
    valueKey: lineKey,
  })),
  getData: (rawData) =>
    rawData.items.map((item) => {
      const result: TChartItem = {
        label: item.label,
        text: item.text,
        column: item.column,
      };

      CHART_LINE_KEYS.forEach((lineKey) => {
        const value = item[lineKey];

        if (value != null) result[lineKey] = value;
      });

      return result;
    }),
});
